import { render, staticRenderFns } from "./NamesComparisonForm.vue?vue&type=template&id=14c53fec&scoped=true&"
import script from "./NamesComparisonForm.vue?vue&type=script&lang=js&"
export * from "./NamesComparisonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c53fec",
  null
  
)

export default component.exports